import { useRef, useState } from 'react';
import { uploadFile } from '../../api/resources';
import { useToast } from '../../context/ToastContext';
import { assetUrl } from '../../utils/format';

const ACCEPT = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

// value: url string | null. onChange(url|null). Shows a thumbnail + replace/remove.
export default function PhotoUpload({ value, onChange, label = 'Add Photo', size = 'h-24 w-24' }) {
  const inputRef = useRef(null);
  const { error } = useToast();
  const [busy, setBusy] = useState(false);

  const pick = async (file) => {
    if (!file) return;
    if (!ACCEPT.includes(file.type)) {
      error('Only JPG, PNG, GIF or WEBP images are allowed.');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      error('Image must be under 5 MB.');
      return;
    }
    setBusy(true);
    try {
      const res = await uploadFile(file);
      onChange(res.url);
    } catch (x) {
      error(x.response?.data?.message || 'Upload failed.');
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <div className="flex items-center gap-3">
      {value ? (
        <img src={assetUrl(value)} alt="preview" className={`${size} rounded-lg border border-line object-cover`} />
      ) : (
        <div className={`${size} flex items-center justify-center rounded-lg border-2 border-dashed border-line-strong bg-surface-sunken text-2xl text-content-subtle`}>
          {busy ? '…' : '🖼'}
        </div>
      )}
      <div className="space-y-1.5">
        <button type="button" className="btn-outline !px-3 !py-1.5 text-xs" onClick={() => inputRef.current?.click()} disabled={busy}>
          {busy ? 'Uploading…' : value ? 'Replace Photo' : label}
        </button>
        {value && (
          <button type="button" className="block text-xs font-medium text-danger-600 hover:underline" onClick={() => onChange(null)}>
            Remove photo
          </button>
        )}
        <input ref={inputRef} type="file" accept="image/*" hidden onChange={(e) => pick(e.target.files?.[0])} />
      </div>
    </div>
  );
}